var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoveSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_3209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 0H0.999984C0.447703 0 0 0.447703 0 0.999984V23C0 23.5523 0.447703 24 0.999984 24H23C23.5522 24 24 23.5523 24 23V0.999984C24 0.447703 23.5523 0 23 0ZM22 22H2.00002V2.00002H22V22H22Z",
    fill: "#9393B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 11C9.20925 11 11 9.2093 11 7.00003C11 4.79077 9.2093 3 6.99998 3C4.79067 3 3 4.79072 3 6.99998C3 9.20925 4.79072 11 6.99998 11ZM6.99998 5.00002C8.10469 5.00002 9 5.89528 9 7.00003C9 8.10478 8.10473 9 6.99998 9C5.89523 9 4.99997 8.10473 4.99997 6.99998C4.99997 5.89523 5.89528 5.00002 6.99998 5.00002Z",
    fill: "#9393B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11C19.2092 11 21 9.2093 21 7.00003C21 4.79077 19.2092 3 17 3C14.7907 3 13 4.79072 13 6.99998C13 9.20925 14.7907 11 17 11ZM17 5.00002C18.1047 5.00002 19 5.89528 19 7.00003C19 8.10478 18.1047 9 17 9C15.8953 9 15 8.10473 15 6.99998C15 5.89523 15.8952 5.00002 17 5.00002Z",
    fill: "#9393B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12C5.34273 12 4 13.3427 4 15C4 16.6573 5.34273 18 7 18C8.65727 18 10 16.6573 10 15C10 13.3427 8.65731 12 7 12ZM7 16C6.4473 16 6.00002 15.5527 6.00002 15C6.00002 14.4473 6.4473 14 7 14C7.5527 14 7.99998 14.4473 7.99998 15C7.99998 15.5527 7.55275 16 7 16Z",
    fill: "#9393B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12C15.3427 12 14 13.3427 14 15C14 16.6573 15.3427 18 17 18C18.6573 18 20 16.6573 20 15C20 13.3427 18.6573 12 17 12ZM17 16C16.4473 16 16 15.5527 16 15C16 14.4473 16.4473 14 17 14C17.5527 14 18 14.4473 18 15C18 15.5527 17.5527 16 17 16Z",
    fill: "#9393B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 19H5.99998C5.4477 19 5 19.4477 5 20C5 20.5523 5.4477 21 5.99998 21H8C8.55228 21 8.99998 20.5523 8.99998 20C8.99998 19.4477 8.55228 19 8 19Z",
    fill: "#9393B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19H16C15.4477 19 15 19.4477 15 20C15 20.5523 15.4477 21 16 21H18C18.5523 21 19 20.5523 19 20C19 19.4477 18.5523 19 18 19Z",
    fill: "#9393B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_3209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoveSvgrepocom);
export default __webpack_public_path__ + "static/media/stove_svgrepo.com.aa2283608a49f7ae12b221e3be3546c0.svg";
export { ForwardRef as ReactComponent };